import { Button } from 'shared/components/ui';
import React, { useState } from 'react';
import { useCatalogos } from '../../calendario/hooks/useCatalogos';
import useHorarioMedico from '../hooks/useHorarioMedico';
import { ToastContainer, ConfirmModal } from '../../../shared/components';
import { Save, Cancel, Delete } from '@mui/icons-material';

const HorarioMedicoForm = ({ horario, onCancelar, onGuardar }) => {
  const { centros, medicos, tecnicos, loading: loadingCatalogos } = useCatalogos();
  const { formData, handleChange, handleSubmit, handleDelete } = useHorarioMedico(horario?.idHorarioMedico || horario?.id);
  const [toast, setToast] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!formData.idCentro) {
      setToast({ message: 'El campo "Centro" es requerido', type: 'error' });
      return;
    }
    if (!formData.tipoMedico) {
      setToast({ message: 'El campo "Especialidad" es requerido', type: 'error' });
      return;
    }
    if (!formData.idMedico) {
      setToast({ message: 'El campo "Médico / Técnico" es requerido', type: 'error' });
      return;
    }
    if (!formData.fechaDesde) {
      setToast({ message: 'El campo "Fecha Desde" es requerido', type: 'error' });
      return;
    }
    if (!formData.fechaHasta) {
      setToast({ message: 'El campo "Fecha Hasta" es requerido', type: 'error' });
      return;
    }
    if (!horario && (!formData.dias || formData.dias.length === 0)) {
      setToast({ message: 'Debe seleccionar al menos un día de la semana', type: 'error' });
      return;
    }

    const success = await handleSubmit();
    if (success) {
      setToast({ message: horario ? 'Horario actualizado exitosamente' : 'Horario creado exitosamente', type: 'success' });
      setTimeout(() => onGuardar(), 1500);
    } else {
      setToast({ message: 'Error al guardar el horario', type: 'error' });
    }
  };

  const onEliminar = async () => {
    const success = await handleDelete();
    if (success) {
      setShowDeleteModal(false);
      setToast({ message: 'Horario eliminado exitosamente', type: 'success' });
      setTimeout(() => onGuardar(), 1500);
    } else {
      setShowDeleteModal(false);
      setToast({ message: 'Error al eliminar el horario', type: 'error' });
    }
  };



  return (
    <>
      <ToastContainer toast={toast} onClose={() => setToast(null)} />
      <ConfirmModal
        show={showDeleteModal}
        title="Eliminar Horario Médico"
        message="¿Está seguro que desea eliminar este horario médico?"
        onConfirm={onEliminar}
        onCancel={() => setShowDeleteModal(false)}
      />
      <div className="horario-medico-form">
      <div className="panel panel-info">
        <div className="panel-heading">
          {horario ? 'Editar Horario Médico' : 'Nuevo Horario Médico'}
        </div>
        <div className="panel-body">
          <form onSubmit={onSubmit}>
            <div className="row" style={{ marginBottom: '15px' }}>
              <div className="col-sm-4">
                <label>* Centro</label>
                <select name="idCentro" className="form-control" value={formData.idCentro} onChange={handleChange} disabled={loadingCatalogos}>
                  <option value="">Seleccione...</option>
                  {centros?.map(c => <option key={c.idCentro} value={c.idCentro}>{c.centro1}</option>)}
                </select>
              </div>

              <div className="col-sm-3">
                <label>* Especialidad</label>
                <div style={{ marginTop: '7px' }}>
                  <label className="radio-inline" style={{ marginRight: '20px' }}>
                    <input type="radio" name="tipoMedico" value="1" checked={formData.tipoMedico === '1'} onChange={handleChange} style={{ marginRight: '5px' }} /> Médico
                  </label>
                  <label className="radio-inline">
                    <input type="radio" name="tipoMedico" value="2" checked={formData.tipoMedico === '2'} onChange={handleChange} style={{ marginRight: '5px' }} /> Técnico
                  </label>
                </div>
              </div>

              <div className="col-sm-5">
                <label>* Médico / Técnico</label>
                <select name="idMedico" className="form-control" value={formData.idMedico} onChange={handleChange} disabled={loadingCatalogos}>
                  <option value="">Seleccione...</option>
                  {(formData.tipoMedico === '1' ? medicos : tecnicos)?.map(m => 
                    <option key={m.idMedico} value={m.idMedico}>{m.medico1}</option>
                  )}
                </select>
              </div>
            </div>

            <div className="row" style={{ marginBottom: '15px' }}>
              <div className="col-sm-3">
                <label>* Fecha Desde</label>
                <input type="date" name="fechaDesde" className="form-control" value={formData.fechaDesde} onChange={handleChange} />
              </div>
              <div className="col-sm-2">
                <label>* Hora</label>
                <select name="horaDesde" className="form-control" value={formData.horaDesde} onChange={handleChange}>
                  {[...Array(24)].map((_, i) => <option key={i} value={i.toString().padStart(2, '0')}>{i.toString().padStart(2, '0')}</option>)}
                </select>
              </div>
              <div className="col-sm-2">
                <label>* Minutos</label>
                <select name="minutosDesde" className="form-control" value={formData.minutosDesde} onChange={handleChange}>
                  {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(m => <option key={m} value={m.toString().padStart(2, '0')}>{m.toString().padStart(2, '0')}</option>)}
                </select>
              </div>
            </div>

            <div className="row" style={{ marginBottom: '15px' }}>
              <div className="col-sm-3">
                <label>* Fecha Hasta</label>
                <input type="date" name="fechaHasta" className="form-control" value={formData.fechaHasta} onChange={handleChange} />
              </div>
              <div className="col-sm-2">
                <label>* Hora</label>
                <select name="horaHasta" className="form-control" value={formData.horaHasta} onChange={handleChange}>
                  {[...Array(24)].map((_, i) => <option key={i} value={i.toString().padStart(2, '0')}>{i.toString().padStart(2, '0')}</option>)}
                </select>
              </div>
              <div className="col-sm-2">
                <label>* Minutos</label>
                <select name="minutosHasta" className="form-control" value={formData.minutosHasta} onChange={handleChange}>
                  {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(m => <option key={m} value={m.toString().padStart(2, '0')}>{m.toString().padStart(2, '0')}</option>)}
                </select>
              </div>
            </div>

            {!horario && (
              <div className="row" style={{ marginBottom: '15px' }}>
                <div className="col-sm-12">
                  <label style={{ display: 'block', marginBottom: '10px' }}>* Días de la Semana</label>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'].map((dia, i) => (
                      <label key={i} style={{ 
                        display: 'inline-flex', 
                        alignItems: 'center',
                        padding: '8px 15px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        backgroundColor: formData.dias?.includes(i) ? '#5bc0de' : '#fff',
                        color: formData.dias?.includes(i) ? '#fff' : '#333',
                        transition: 'all 0.2s',
                        userSelect: 'none'
                      }}>
                        <input 
                          type="checkbox" 
                          name="dias" 
                          value={i} 
                          checked={formData.dias?.includes(i)} 
                          onChange={handleChange}
                          style={{ marginRight: '8px' }}
                        /> 
                        {dia}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="row" style={{ marginBottom: '15px' }}>
              <div className="col-sm-12">
                <label>Observación</label>
                <textarea name="observacion" className="form-control" rows="3" value={formData.observacion} onChange={handleChange} />
              </div>
            </div>

            <div className="form-actions">
              <Button type="submit" className="btn btn-success">
                <Save sx={{ fontSize: 18, mr: 0.5 }} />
                Guardar
              </Button>
              <Button type="button" className="btn btn-default" onClick={onCancelar}>
                <Cancel sx={{ fontSize: 18, mr: 0.5 }} />
                Cancelar
              </Button>
              {horario && (
                <Button type="button" className="btn btn-danger" onClick={() => setShowDeleteModal(true)}>
                  <Delete sx={{ fontSize: 18, mr: 0.5 }} />
                  Eliminar
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default HorarioMedicoForm;
